import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import { imagePrettyUrl, getAltText } from 'gatsby-core-theme/src/helpers/getters';
import LazyImage from 'gatsby-core-theme/src/hooks/lazy-image';
import StarRating from 'gatsby-core-theme/src/components/molecules/star-rating/one-star';
import { FaStar } from '@react-icons/all-files/fa/FaStar';
import useTranslate from '~hooks/useTranslate/useTranslate';
import Verify from '~images/icons/verify';
import Rating from '../../../../../atoms/ratings';
import OperatorBanner from '../../../../../atoms/header-operator-bannner';
import VariableComponent from '../variables';
import styles from './template-one-two.module.scss';
import { TrackingKeys } from '~constants/tracking-api'
import PrettyLink from '~atoms/pretty-link';

const TemplateOneTwo = ({
  relation,
  type,
  image,
  name,
  pageTemplate,
  numOfStars = 5,
  icon,
  hasVariableComponent = false,
  moduleName = TrackingKeys?.HEADEROPERATOR,
  template = 'template_one',
  showRoundedRating = false,
  width = 179,
  height = 179,
}) => {
  const ribbon = relation.ribbons?.length > 0 ? relation.ribbons[0] : null;

  const logo = () => (
    <PrettyLink
      operator={relation}
      pageTemplate={pageTemplate}
      moduleName={moduleName}
      tracker="main"
      clickedElement="operator_logo"
      className="header-gtm logo-cta "
    >
      <LazyImage
        loading="eager"
        src={imagePrettyUrl(image?.filename, width, height)}
        width={width}
        height={height}
        alt={getAltText(image, relation?.name)}
      />
    </PrettyLink>
  );

  const TBAtext = useTranslate('tba', 'TBA');

  return (
    <div
      className={`${styles.container} ${template === 'template_two' && styles.templateTwoContainer
        } ${hasVariableComponent ? styles.hasVariableComponent : ''}`}
    >
      <div
        className={`${styles.topSection} ${template === 'template_two' && styles.templateTwoTopSection
          }`}
      >
        {logo()}
        <div
          className={`${styles.topContent} ${template === 'template_two' && styles.templateTwoTopContent
            }`}
        >
          <div className={styles.name}>
            <h1>{name}</h1>
            {icon || <Verify />}
          </div>
          {ribbon && (
            <p
              className={`${styles.ribbon} ${template === 'template_two' && styles.templateTwoRibbon
                }`}
            >
              {ribbon}
            </p>
          )}
          {!['coming_soon', 'inactive'].includes(relation?.status) ? (
            <StarRating
              numOfStars={numOfStars}
              rating={numOfStars < 6 ? relation?.rating : Math.round(relation?.rating * 2)}
              icon={<FaStar title="Star Icon" />}
              showDot={false}
              showRoundedRating={showRoundedRating}
            />
          ) : (
            <div className={styles.ratingInactive}>
              <FaStar title="Star Icon" />
              {TBAtext}
            </div>
          )}
        </div>
      </div>
      <Rating item={relation} type={type} numOfStars={numOfStars} />

      {hasVariableComponent && (
        <VariableComponent
          relation={relation}
          pageTemplate={pageTemplate}
          className={styles.variable}
        />
      )}

      <OperatorBanner clickedElement="header_operator_banner" moduleName={moduleName} logo={image} operator={relation} template={pageTemplate} />
    </div>
  );
};

TemplateOneTwo.propTypes = {
  relation: PropTypes.shape({
    type: PropTypes.string,
    template: PropTypes.string,
    name: PropTypes.string,
    rating: PropTypes.string,
    status: PropTypes.string,
    ribbons: PropTypes.arrayOf(PropTypes.string),
  }),
  name: PropTypes.string,
  type: PropTypes.string,
  hasVariableComponent: PropTypes.bool,
  image: PropTypes.shape({
    filename: PropTypes.string,
  }),
  pageTemplate: PropTypes.string,
  numOfStars: PropTypes.number,
  template: PropTypes.string,
  icon: PropTypes.node,
  showRoundedRating: PropTypes.bool,
  width: PropTypes.number,
  height: PropTypes.number,
  moduleName: PropTypes.string,
};

export default TemplateOneTwo;
